<template>
    <div class="SubProgramSettingsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Program:</label>
                        <select v-model="TargetSubProgramID" class="form-control">
                            <option v-for="subprogram in SubProgramOptions" :value="subprogram.value">
                                {{subprogram.text}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row" v-if="TargetSubProgramID" :key="TargetSubProgramID">
                <div class="col-md-6">
                    <h4>Distribution Lists</h4>
                    <p>Distribution Lists are collections of email addresses for people to receive specific notifications.  All email addresses should be separated by a comma.</p>
                    <DistributionListEditor :sub-program-id="TargetSubProgramID" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    //import components
    import DistributionListEditor from './DistributionListEditor.vue';
    export default {
        props: [],
        data: function () {
            return {
                TargetSubProgramID: "",
                SubProgramSettings: {}
            };
        },
        methods: {

        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        },
        components: {
            DistributionListEditor
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>